<template>
  <div class="mailing-container" :class="{'no-total-container': noResultState}">
    <w-nav-bar nav_title="我的收藏" @mobileLeftBtn="back"/>
    <div class="mailing-tab flex-start">
      <div class="mailing-tab-item" v-for="item in tabList" :key="item.id"
           :class="{'mailing-tab-item-active': item.id === currentId}" @click="changeId(item)">
        {{ item.title }}
      </div>
    </div>
    <div class="list-container">
      <cube-scroll :data="currentId === 2 ? applicationList : favoriteList" :options="options" @pulling-up="onPullingUp">
        <company-list v-show="currentId === 2 && applicationTotal" :list-data="applicationList" />
        <job-list v-show="currentId === 1 && favoriteTotal" :list-data="favoriteList" :show-update="true"/>
        <w-more-loading v-show="moreShow"></w-more-loading>
        <w-no-more v-show="isEnd"></w-no-more>
      </cube-scroll>
      <w-no-result v-show="noResultState" :text="noResultText"></w-no-result>
    </div>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import jobList from '../job-components/job-list-mailing'
	import companyList from '../job-components/company-list'
	import WMoreLoading from '../../components/global/w-more-loading'
	import WNoMore from '../../components/global/w-no-more'
	import WNoResult from '../../components/global/w-no-result'

	export default {
		name: 'job-mailing',
		data () {
			return {
				currentId: 1,
				favoriteList: [],
				applicationList: [],
				favoritePage: 1,
				favoriteTotal: 0,
				favoriteTotal: 0,
				applicationPage: 1,
				applicationTotal: 0,
				options: {
					pullUpLoad: true
				}
			}
		},
		mounted () {
			this._getFavoriteList()
		},
		computed: {
			noResultState () {
				return (this.currentId === 2 && !this.applicationTotal) || (this.currentId === 1 && !this.favoriteTotal)
			},
			noResultText () {
				return this.currentId === 2 ? '暂无关注公司' : '暂无收藏职位'
      },
			tabList () {
				return [
          { id: 1, title: '收藏职位' },
					{ id: 2, title: '关注公司' }
				]
			},
			moreShow () {
				if (this.currentId === 1) {
					return this.favoriteList.length < this.favoriteTotal
				} else if (this.currentId === 2) {
					return this.applicationList.length < this.applicationTotal
				}
			},
			isEnd () {
				if (this.currentId === 1) {
					return this.favoriteList.length === this.favoriteTotal && this.favoriteTotal
				} else if (this.currentId === 2) {
					return this.applicationList.length === this.applicationTotal && this.applicationTotal
				}
			}
		},
		watch: {},
		components: {
			WNavBar,
			jobList,
      companyList,
			WMoreLoading,
			WNoMore,
			WNoResult
		},
		methods: {
			back () {
				this.$router.back()
			},
			// 上拉加载
			onPullingUp () {
				if (this.currentId === 1 && !this.isEnd) {
					this.favoritePage += 1
					this._getFavoriteList()
				} else if (this.currentId === 2 && !this.isEnd) {
					this.applicationPage += 1
					this._getApplicationList()
				}
			},
			// 切换tab
			changeId ({ id }) {
				this.currentId = id
				if (id === 1 && !this.favoriteList.length) {
					this._getFavoriteList()
				} else if (id === 2 && !this.applicationList.length) {
					this._getApplicationList()
				}
			},
			// 获取收藏职位列表
			async _getFavoriteList (init) {
				let res = await this.$api.jobs.getFavoriteList({
					page: this.favoritePage,
					page_size: 10
				})
				if (res.code === 1000) {
					this.favoriteList = [ ...this.favoriteList, ...res.data.favorite_jobs ]
					this.favoriteTotal = res.data.favorite_job_count
				}
			},
			// 获取关注公司列表
			async _getApplicationList (init) {
				let res = await this.$api.jobs.getFollowList({
					page: this.applicationPage,
					page_size: 10
				})
				if (res.code === 1000) {
					this.applicationList = [ ...this.applicationList, ...res.data.company_list ]
					this.applicationTotal = res.data.total_count
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .mailing-container {
    @include mobile-container(90px, 1px);
    height: calc(var(--vh, 1vh) * 100);
    background-color: #F9F9F9;
    .mailing-tab {
      position: fixed;
      top: 44px;
      width: 100vw;
      height: 46px;
      padding: 0 24px;
      background-color: $color-light;
      .mailing-tab-item {
        color: #9C9C9C;
        margin-right: 24px;
      }
      .mailing-tab-item-active {
        color: $color-title;
        font-weight: 500;
      }
    }
    .list-container {
      height: calc(calc(var(--vh, 1vh) * 100) - 90px);
      /deep/ .recommend-item {
        padding: 20px 24px;
        margin-bottom: 6px;
        &:first-child {
          padding-top: 16px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .no-total-container {
    background-color: $color-light;
  }
</style>
